import { CopyButton } from '@ts/components/CopyButton';
import { Share } from '@ts/components/Share';
import { scrollToElement } from '@ts/utils';
import { icon } from "@fortawesome/fontawesome-svg-core";
import htmx from 'htmx.org';
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

export const init = () => {
    setInteractiveElements();
    setInlineShareParticipantMessage();
    setInvitePreview();
}

const setInteractiveElements = () => {
    setContactsFormListener();
}

const handleContactsSettled = (evt) => {
    const table = evt.detail.elt;
    if (table?.id !== 'add-contacts-table') return;

    handleContactsSubmission(evt, table);
};

const setContactsFormListener = () => {
    const container = document.querySelector('.invite-team-container');
    if (!container) return;
    container.removeEventListener('htmx:afterSettle', handleContactsSettled);
    container.addEventListener('htmx:afterSettle', handleContactsSettled);
};

const handleContactsSubmission = (evt, addContactsTable) => {
    const validationStatus = evt.detail.xhr.getResponseHeader('x-validation-status');
    if (validationStatus?.toLowerCase() === 'false') return;
    
    const sendFlag = addContactsTable?.querySelector('#Send');
    if (!sendFlag) return;
    
    if (sendFlag.value.toLowerCase() === 'false') {
        showEmailPreview();
    } else {
        showSuccessMessage();
    }
}

const getFirstValidFirstName = (contactsContainer) => {
    const rows = contactsContainer.querySelectorAll('.address-import-row');
    for (const row of rows) {
        const firstNameInput = row.querySelector('.address-import-first-name');
        const hasError = row.querySelector('.contact-first-name .text-danger')?.textContent.trim();
        const firstName = firstNameInput?.value.trim();
        if (firstName && !hasError) return firstName;
    }
    return null;
}

const showEmailPreview = () => {
    const inviteContainer = document.querySelector('.invite-team-container');
    const emailPreview = inviteContainer?.querySelector('.email-preview');
    const contactsContainer = inviteContainer?.querySelector('.add-contacts-container');
    const sendFlag = inviteContainer?.querySelector('#Send');
    const greetingName = emailPreview?.querySelector('.email-greeting-name');
    if (!inviteContainer || !emailPreview || !contactsContainer || !sendFlag || !greetingName) return;

    const firstName = getFirstValidFirstName(contactsContainer);
    if (firstName) greetingName.textContent = firstName;

    contactsContainer.hidden = true;
    emailPreview.hidden = false;
    sendFlag.value = 'True';
    scrollToElement(emailPreview);
}

const showSuccessMessage = () => {
    const inviteContainer = document.querySelector('.invite-team-container');
    const emailPreview = inviteContainer?.querySelector('.email-preview');
    const contactsContainer = inviteContainer?.querySelector('.add-contacts-container');
    const sendEmailSuccess = inviteContainer?.querySelector('.send-email-success');
    if (!inviteContainer || !emailPreview || !contactsContainer || !sendEmailSuccess) return;

    contactsContainer.hidden = true;
    emailPreview.hidden = true;
    sendEmailSuccess.dataset.shareStatus = 'shared';
    scrollToElement(sendEmailSuccess);
}

const handleSubmitInvite = () => {
    const inviteContainer = document.querySelector('.invite-team-container');
    const contactsContainer = inviteContainer?.querySelector('.add-contacts-container');
    const form = contactsContainer?.querySelector('form');
    if (!form) return;
    htmx.trigger(form, 'submit');
}

const handleCancelInvite = (contactsContainer, emailPreview) => {
    const sendFlag = document.getElementById('Send');
    if (!sendFlag) return;
    contactsContainer.hidden = false;
    emailPreview.hidden = true;
    sendFlag.value = 'False';
    scrollToElement(contactsContainer);
}

const setInvitePreview = () => {
    const inviteContainer = document.querySelector('.invite-team-container');
    const emailPreview = inviteContainer?.querySelector('.email-preview');
    const previewButton = inviteContainer?.querySelector('.preview-invite');
    const backToEditButton = inviteContainer?.querySelector('.back-to-edit');
    const submitContacts = inviteContainer?.querySelector('.submit-contacts');
    const contactsContainer = inviteContainer?.querySelector('.add-contacts-container');
    
    if (!contactsContainer || !emailPreview || !previewButton || !backToEditButton) return;

    previewButton.addEventListener('click', (e) => {
        e.preventDefault();
        handleSubmitInvite();
    });

    backToEditButton.addEventListener('click', (e) => {
        e.preventDefault();
        handleCancelInvite(contactsContainer, emailPreview);
    });

    submitContacts.addEventListener('click', (e) => {
        e.preventDefault();
        handleSubmitInvite();
    });
}

const setInlineShareParticipantMessage = () => {
    const shareButton = document.querySelector('#share-inline-participant-message-btn');
    if (!shareButton) return;
    const webshare = Share.create(shareButton, {
        text: document.querySelector('.funderworks-share-invite-message')?.textContent,
        onSuccess: (event) => handleShareSuccess(shareButton),
        onFail: (event) => handleShareFail()
    });
}

const handleShareFail = () => {
    const postShareContent = document.querySelector('.post-share-success');
    if (!postShareContent) return;
    postShareContent.dataset.shareStatus = 'failed';
}

const handleShareSuccess = async (copyBtn) => {
    const confirmShareUrl = copyBtn.dataset.confirmShare;
    if (!confirmShareUrl) return;

    const response = await fetch(confirmShareUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
    });
    
    if (!response.ok) {
        throw new Error(`Confirm share failed: ${response.status}`);
        return;
    }

    togglePostShareSuccess();
}

const togglePostShareSuccess = () => {
    const postShareContent = document.querySelector('.post-share-success');
    if (!postShareContent) return;
    postShareContent.dataset.shareStatus = 'shared';
}

const createIconSvg = (iconDefinition) => {
    const iconMarkup = icon(iconDefinition);
    const svgHtml = iconMarkup.html[0] ?? "";
    const fragment = document.createRange().createContextualFragment(svgHtml);
    const svg = fragment.firstElementChild;
    svg.setAttribute("aria-hidden", "true");
    return svg;
}